import { themeStore } from "@/stores/theme";
import { useTranslate } from "@/utils/lang";
import { AlbumWords } from "@/utils/lang/album";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Flex,
  Button,
  useBoolean,
  Text,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { albumStore } from "../store";
import { OpModalBaseProps } from "../type";

type DeleteImagesModalProps = OpModalBaseProps & {
  albumId: number;
  imageIds: number[];
  onDelete?: () => void;
};

function IDeleteAlbumImagesModal(props: DeleteImagesModalProps) {
  const { panelBg } = themeStore.styles;
  const { isOpen, onClose, onDelete, albumId, imageIds, store = albumStore } = props;
  const [loading, setLoading] = useBoolean(false);
  const { translate } = useTranslate();

  const deleteImagesContent = {
    title: translate(AlbumWords.deleteModalTitle),
    text: translate(AlbumWords.deleteModalContent),
    cancelBtn: translate(AlbumWords.cancel),
    confirmBtn: translate(AlbumWords.confirmDelete),
    loading: translate(AlbumWords.deleting),
  };

  const handleConfirm = () => {
    setLoading.on();
    store
      .deletePictures(albumId, imageIds)
      .then(() => {
        onClose();
        onDelete?.();
      })
      .finally(setLoading.off);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent bg={panelBg} w="716px" mt="278px">
        <ModalHeader color="white" textAlign="center" pt="40px" fontSize="32px">
          {deleteImagesContent.title}
        </ModalHeader>
        <ModalCloseButton color="white" />
        <ModalBody px="88px">
          <Text color="#dcdcdc" textAlign="center">
            {deleteImagesContent.text}
          </Text>
          <Flex justify="center" mt="58px" mb="48px">
            <Button variant="dark.solid" w="140px" mr="14px" onClick={onClose}>
              {deleteImagesContent.cancelBtn}
            </Button>
            <Button
              variant="primary"
              w="140px"
              bg="#ff5050"
              borderColor="#ff5050"
              _hover={{
                bg: "#ff5050",
              }}
              disabled={loading}
              isLoading={loading}
              loadingText={deleteImagesContent.loading}
              onClick={handleConfirm}
            >
              {deleteImagesContent.confirmBtn}
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export const DeleteAlbumImagesModal = observer(IDeleteAlbumImagesModal);
